import * as React from 'react';

import styles from './CarouselSlide.css';
import { ScrollFade } from '@cian/adfox-templates';

export type CarouselSlidePros = {
  height: number;
  width: number;
  imageSrc: string;
  title: string;
  description: string;
};

export const CarouselSlide: React.FC<CarouselSlidePros> = props => {
  const { imageSrc, height, width, title, description } = props;

  return (
    <div className={styles['container']}>
      <img
        loading="lazy"
        decoding="async"
        alt={title}
        className={styles['image']}
        src={imageSrc}
        width={width}
        height={height}
      />
      <span className={styles['title']}>{title}</span>
      <div className={styles['description']}>
        <span className={styles['description-text']}>
          {description}
          <ScrollFade size={28} />
        </span>
      </div>
    </div>
  );
};
